import { useState } from "react";
import  "./BalanceLevel.css";


const BalanceLevel = ({data,handleChange, count})=>{
  const [val, setVal] = useState(data.balancelevel===0?0:data.balancelevel);

  function onChangeValue(event) {
    setVal(event.target.value);
    console.log(event.target.value+2);
    handleChange(event);
  }
    return (
  <div class="BalanceLevelCard" className="balanceLevel" onChange={onChangeValue}>
    <div class="BalanceLevel-rating-container">
      
      <div class="BalanceLevel-rating">
        <form class="BalanceLevel-rating-form-1" >

          <label for={`BLI1F-${count}`}>
            <input type="radio"  name="balancelevel" class="BalanceLevel1" id={`BLI1F-${count}`} value="6"  checked={'' + val === "6"} />
                <div className="aromacircle1"></div>
                <p>6</p>
           </label>
  
          <label for={`BLI2F-${count}`}>
              <input type="radio" name="balancelevel" class="BalanceLevel2" id={`BLI2F-${count}`} value="6.25" checked={'' + val === "6.25"} />
                <div className="aromacircle2"></div>
               <p className="invisible">.5</p>
           </label>
  
          <label for={`BLI3F-${count}`}>
              <input type="radio" name="balancelevel" class="BalanceLevel3" id={`BLI3F-${count}`} value="6.5" checked={'' + val === "6.5"} />
                <div className="aromacircle3"></div>
                <p className="invisible">.5</p>
            </label>
  
          <label for={`BLI4F-${count}`}>
             <input type="radio" name="balancelevel" class="BalanceLevel4" id={`BLI4F-${count}`} value="6.75" checked={'' + val === "6.75"} />
               <div className="aromacircle4"></div>
               <p className="invisible">.5</p>
       
            </label>
  
          <label for={`BLI5F-${count}`}>
             <input type="radio" name="balancelevel" class="BalanceLevel5" id={`BLI5F-${count}`} value="7" checked={'' + val === "7"} />
                <div className="aromacircle5"></div>
                <p>7</p>
             </label>
             {/* Didn't change it after this */}
             <label for={`BLI6F-${count}`}>
             <input type="radio" name="balancelevel" class="BalanceLevel6" id={`BLI6F-${count}`} value="7.25" checked={'' + val === "7.25"} />
                <div className="aromacircle6"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`BLI7F-${count}`}>
             <input type="radio" name="balancelevel" class="BalanceLevel7" id={`BLI7F-${count}`} value="7.5" checked={'' + val === "7.5"} />
                <div className="aromacircle7"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`BLI8F-${count}`}>
             <input type="radio" name="balancelevel" class="BalanceLevel8" id={`BLI8F-${count}`} value="7.75" checked={'' + val === "7.75"} />
                <div className="aromacircle8"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`BLI9F-${count}`}>
             <input type="radio" name="balancelevel" class="BalanceLevel9" id={`BLI9F-${count}`} value="8" checked={'' + val === "8"} />
                <div className="aromacircle9"></div>
                <p>8</p>
                
             </label>

             <label for={`BLI10F-${count}`}>
             <input type="radio" name="balancelevel" class="BalanceLevel10" id={`BLI10F-${count}`} value="8.25" checked={'' + val === "8.25"} />
                <div className="aromacircle10"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`BLI11F-${count}`}>
             <input type="radio" name="balancelevel" class="BalanceLevel11" id={`BLI11F-${count}`} value="8.5" checked={'' + val === "8.5"} />
                <div className="aromacircle11"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`BLI12F-${count}`}>
             <input type="radio" name="balancelevel" class="BalanceLevel12" id={`BLI12F-${count}`} value="8.75" checked={'' + val === "8.75"} />
                <div className="aromacircle12"></div>
                <p className="invisible">.5</p>
             </label>


             <label for={`BLI13F-${count}`}>
             <input type="radio" name="balancelevel" class="BalanceLevel13" id={`BLI13F-${count}`} value="9" checked={'' + val === "9"} />
                <div className="aromacircle13"></div>
                
                <p>9</p>
             </label>

             <label for={`BLI14F-${count}`}>
             <input type="radio" name="balancelevel" class="BalanceLevel14" id={`BLI14F-${count}`} value="9.25" checked={'' + val === "9.25"} />
                <div className="aromacircle14"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`BLI15F-${count}`}>
             <input type="radio" name="balancelevel" class="BalanceLevel15" id={`BLI15F-${count}`} value="9.5" checked={'' + val === "9.5"} />
                <div className="aromacircle15"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`BLI16F-${count}`}>
             <input type="radio" name="balancelevel" class="BalanceLevel16" id={`BLI16F-${count}`} value="9.75" checked={'' + val === "9.75"} />
                <div className="aromacircle16"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`BLI17F-${count}`}>
             <input type="radio" name="balancelevel" class="BalanceLevel17" id={`BLI17F-${count}`} value="10" checked={'' + val === "10"} />
                <div className="aromacircle17"></div>
                <p>10</p>
             </label>



        </form>
      </div>
    </div>
  </div>
  

    );
}

export default BalanceLevel;